var employerAgreementService = function ($q, cacheManagerService) {
    // Actual interaction with the back end
    this.getTerms = function (portalUrl) {
        var deferred = $q.defer();

        cacheManagerService.get({
            url: siteGlobal.apiResourceLocation + '/api/EmployerAgreement/GetTerms',
            params: { PortalUrl: portalUrl },
        })
        .then(
            function (data) {
                deferred.resolve(data);
            },
            function (data, status, headers, config) {
                siteGlobal.logError(data, "employerAgreementService.getTerms", { data: data, status: status, headers: headers, config: config } );
            });

        return deferred.promise;
    };
}
